/** Shared, always-visible close control for scrollable modal cards. */
export function createModalCloseButton(
  onClose: () => void,
  ariaLabel = "Close",
): HTMLButtonElement {
  const button = document.createElement("button");
  button.type = "button";
  button.className = "modalCornerCloseBtn";
  button.setAttribute("aria-label", ariaLabel);
  button.title = ariaLabel;
  button.innerHTML =
    '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
    '<path d="M6 6l12 12M18 6L6 18" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round"/>' +
    "</svg>";
  button.onclick = (event) => {
    event.stopPropagation();
    onClose();
  };
  return button;
}
